import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "../../Containers/ContainerCreate";
import { getSearchResults } from "../../api/getSearch";

class SearchResultsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { results: [] };
  }
  componentDidMount() {
    const { params } = this.props;
    this.props.request(params);
  }

  componentDidUpdate(prevProps) {
    if (this.props.params !== prevProps.params) {
      this.props.request(this.props.params);
    }
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const results = (data && data.data) || {};
    return render({ results, loading, failure });
  };
}

SearchResultsContainer.propTypes = {
  params: PropTypes.object.isRequired,
};

export default CreateContainer(getSearchResults, SearchResultsContainer);
